"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PurePayment = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _api = require("../../api");
var _paymentSlice = require("../../redux/paymentSlice");
var _Button = _interopRequireDefault(require("../Button"));
var _Adyen = _interopRequireDefault(require("../Adyen"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _validators = require("../DeliveryDetails/RecipientForm/validators");
var _finalizePaymentSlice = require("../../redux/finalizePaymentSlice");
var _deliveryDetailsSlice = require("../../redux/deliveryDetailsSlice");
var _auth = _interopRequireDefault(require("../../services/auth"));
var _paymentMethodHelper = require("../../util/paymentMethodHelper");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _orderSlice = require("../../redux/orderSlice");
var _paymentMethodsSlice = require("../../redux/paymentMethodsSlice");
var _store = require("../../redux/store");
var _PaymentStyled = require("./PaymentStyled");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _PayPal = _interopRequireDefault(require("./PayPal/PayPal"));
var _DropInSection = _interopRequireDefault(require("./DropInSection/DropInSection"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Payment = _ref => {
  let {
    onPaymentComplete
  } = _ref;
  const {
    paymentMethods: publisherPaymentMethods,
    isPayPalHidden,
    visiblePaymentMethods
  } = (0, _store.useAppSelector)(_publisherConfigSlice.selectPublisherConfig);
  const order = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const deliveryDetails = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    requiredPaymentDetails: isPaymentDetailsRequired
  } = order;
  const {
    loading: isPaymentFinalizationInProgress
  } = (0, _store.useAppSelector)(_finalizePaymentSlice.selectFinalizePayment);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [generalError, setGeneralError] = (0, _react.useState)('');
  const [adyenKey, setAdyenKey] = (0, _react.useState)(null);
  const [standardDropInInstance, setStandardDropInInstance] = (0, _react.useState)(null);
  const [bankDropInInstance, setBankDropInInstance] = (0, _react.useState)(null);
  const [isActionHandlingProcessing, setIsActionHandlingProcessing] = (0, _react.useState)(false);
  const dispatch = (0, _store.useAppDispatch)();

  // order updates
  const updateOrderWithPaymentMethodId = methodId => {
    setGeneralError('');
    const {
      id
    } = order;
    if (id && methodId) {
      // TODO: (nice to have) validate if order.paymentId !== methodId. Pay attention to redux store and async
      dispatch((0, _orderSlice.fetchUpdateOrder)({
        id,
        payload: {
          paymentMethodId: methodId
        }
      })).unwrap().catch(errors => {
        if (errors.includes('JWT')) {
          (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_AUTH_FAILED);
          _auth.default.logout(); // TODO: support properly the logout function
        }
      });
    }
  };

  // payment methods
  const selectPaymentMethodHandler = paymentMethodName => {
    const paymentMethodObj = publisherPaymentMethods.find(_ref2 => {
      let {
        methodName
      } = _ref2;
      return methodName === paymentMethodName;
    });
    if (paymentMethodObj) {
      dispatch((0, _paymentMethodsSlice.setSelectedPaymentMethod)(paymentMethodObj));
      updateOrderWithPaymentMethodId(paymentMethodObj.id);
    }
  };
  const fetchPaymentMethods = async () => {
    setIsLoading(true);
    const response = await (0, _api.getPaymentMethods)();
    const {
      paymentMethods: paymentMethodsFromBackend
    } = response.responseData;
    const validMethodsFromResponse = (0, _paymentMethodHelper.validatePaymentMethods)(paymentMethodsFromBackend, false);
    if (response.errors.length) {
      setGeneralError(t('payment.error.cannot-fetch-payment-methods', 'Cannot fetch payment methods'));
      return;
    }
    dispatch((0, _publisherConfigSlice.updatePaymentMethods)(validMethodsFromResponse));
    setIsLoading(false);
    if (!(validMethodsFromResponse !== null && validMethodsFromResponse !== void 0 && validMethodsFromResponse.length)) {
      setGeneralError(t('payment.error.payment-methods-not-defined', 'Payment methods are not defined'));
    }
  };
  (0, _react.useEffect)(() => {
    if (publisherPaymentMethods.length === 1) {
      const [paymentMethod] = publisherPaymentMethods;
      selectPaymentMethodHandler(paymentMethod.methodName);
    }
  }, [publisherPaymentMethods]);
  const handlePayPalError = () => {
    const {
      search
    } = window.location;
    if (search !== null && search !== void 0 && search.includes('message')) {
      setGeneralError(t('payment.error.paypal-not-processed', 'Your payment was not processed. Please, try again'));
    }
  };
  (0, _react.useEffect)(() => {
    fetchPaymentMethods();
    handlePayPalError();
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PAYMENT);
  }, []);

  // PayPal
  const submitPayPal = async () => {
    const {
      isGift
    } = deliveryDetails;
    const {
      id,
      buyAsAGift
    } = order;
    if (isGift) {
      const areDeliveryDetailsValid = (0, _validators.validateDeliveryDetailsForm)();
      if (!areDeliveryDetailsValid) {
        return;
      }
      const {
        recipientEmail,
        deliveryDate,
        deliveryTime,
        message
      } = deliveryDetails;
      await dispatch((0, _orderSlice.fetchUpdateOrder)({
        id: order.id,
        payload: {
          buyAsAGift: true,
          deliveryDetails: {
            recipientEmail: recipientEmail.value,
            personalNote: message.value,
            deliveryDate: new Date("".concat(deliveryDate.value, "T").concat(deliveryTime.value)).valueOf() / 1000
          }
        }
      })).unwrap().catch(err => {
        throw new Error(err);
      });
    }
    if (buyAsAGift && !isGift) {
      await dispatch((0, _orderSlice.fetchUpdateOrder)({
        id,
        payload: {
          buyAsAGift: false
        }
      })).unwrap().catch(err => {
        throw new Error(err);
      });
    }
    setIsLoading(true);
    const {
      responseData
    } = await (0, _api.submitPayPalPayment)();
    if (responseData !== null && responseData !== void 0 && responseData.redirectUrl) {
      window.location.href = responseData.redirectUrl;
    } else {
      setIsLoading(false);
      setGeneralError(t('payment.error.paypal-failed', 'The payment failed. Please try again.'));
    }
  };

  // Adyen
  const onAdditionalDetails = async state => {
    const {
      data: {
        details
      }
    } = state;
    dispatch((0, _finalizePaymentSlice.fetchFinalizeInitialPayment)({
      orderId: order.id,
      details
    }));
  };
  const onAdyenSubmit = async (state, component) => {
    const {
      data: {
        paymentMethod,
        browserInfo,
        billingAddress
      }
    } = state;
    setGeneralError('');
    setIsLoading(true);
    const {
      errors,
      responseData
    } = await (0, _api.submitPayment)(paymentMethod, browserInfo, billingAddress);
    if (errors !== null && errors !== void 0 && errors.length) {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_FAILED, {
        reason: errors[0]
      });
      const notSupportedMethod = errors[0].includes('Payment details are not supported');
      setGeneralError(notSupportedMethod ? t('payment.error.payment-method-not-supported', 'Payment method not supported. Try different payment method') : t('payment.error.payment-not-processed', 'The payment has not been processed. Please, try again with a different payment method.'));
      setIsLoading(false);
      // force Adyen remount
      setStandardDropInInstance(null);
      setBankDropInInstance(null);
      setAdyenKey(key => key ? null : 1);
      return;
    }
    const {
      action,
      payment
    } = responseData;
    if (action) {
      if (action.type !== 'redirect') {
        setIsActionHandlingProcessing(true);
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      component.handleAction(action);
      return;
    }
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
      payment
    });
    if (onPaymentComplete) {
      onPaymentComplete();
    }
  };
  const getDropIn = (drop, type) => {
    // TODO check if paymentMethodType is correct
    if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
      setBankDropInInstance(drop);
    } else {
      setStandardDropInInstance(drop);
    }
  };

  // Payment without payment details
  const paymentWithoutDetails = async () => {
    setIsLoading(true);
    setGeneralError('');
    dispatch((0, _paymentSlice.submitPaymentWithoutDetails)()).unwrap().then(payment => {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
        payment
      });
      if (onPaymentComplete) {
        onPaymentComplete();
      }
    }).catch(() => {
      setIsLoading(false);
      setGeneralError(t('payment.error.failed', 'The payment failed. Please try again.'));
    });
  };
  const shouldShowPayPal = isPayPalHidden ? false : (0, _paymentMethodHelper.shouldShowGatewayComponent)('paypal', publisherPaymentMethods);
  const availablePaymentMethods = (0, _paymentMethodHelper.getAvailablePaymentMethods)(publisherPaymentMethods, visiblePaymentMethods);
  const shouldShowAdyen = (0, _paymentMethodHelper.shouldShowGatewayComponent)('adyen', availablePaymentMethods);
  const noPaymentMethods = !publisherPaymentMethods.length || !availablePaymentMethods.length && !shouldShowPayPal;
  const showPayPalWhenAdyenIsReady = () => shouldShowAdyen ? !!standardDropInInstance || !!bankDropInInstance : true;
  if (noPaymentMethods && !isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentStyled.PaymentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
        marginTop: "25px",
        center: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t('payment.purchase-using', 'Purchase using')
        })
      }), generalError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
        children: generalError
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
        children: t('payment.error.payment-methods-not-available', 'Payment methods not available')
      })]
    });
  }
  if (!isPaymentDetailsRequired) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentStyled.PaymentStyled, {
      children: [generalError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
        children: generalError
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        onClickFn: paymentWithoutDetails,
        theme: "confirm",
        width: "250px",
        size: "big",
        margin: "20px auto 0 auto",
        children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          buttonLoader: true,
          color: "#ffffff"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t('Complete purchase')
        })
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentStyled.PaymentStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
      marginTop: "25px",
      paddingBottom: "33px",
      center: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: t('payment.purchase-using', 'Purchase using')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentStyled.PaymentWrapperStyled, {
      children: [isPaymentFinalizationInProgress && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {}), shouldShowAdyen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Adyen.default, {
        onSubmit: onAdyenSubmit,
        selectPaymentMethod: selectPaymentMethodHandler,
        isPayPalAvailable: shouldShowPayPal,
        getDropIn: getDropIn,
        onAdditionalDetails: onAdditionalDetails
      }, adyenKey), shouldShowPayPal && showPayPalWhenAdyenIsReady() && !isActionHandlingProcessing && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropInSection.default, {
        selectPaymentMethod: selectPaymentMethodHandler,
        title: "PayPal",
        logo: "paypal",
        isLoading: isLoading,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PayPal.default, {
          totalPrice: order.totalPrice,
          offerId: order.offerId,
          onSubmit: submitPayPal,
          isLoading: isLoading
        })
      }), generalError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
        children: generalError
      })]
    })]
  });
};
exports.PurePayment = Payment;
var _default = exports.default = Payment;